import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
    title?: string;
    description?: string;
    image?: string;
    url?: string;
    type?: 'website' | 'article' | 'product';
    keywords?: string;
    noIndex?: boolean;
}

const defaultMeta = {
    title: 'Publee - Gere Publis Hiper-Realistas com IA',
    description: 'Chega de influencer que some depois do pix. Gere publis hiper-realistas com IA. Seu produto + nossa inteligência = vendas no automático.',
    image: 'https://publee.art/og-image.png',
    url: 'https://publee.art',
    keywords: 'publi, influenciador virtual, UGC, IA, marketing, vídeos automatizados, TikTok, Reels, Shorts',
};

export function SEOHead({
    title,
    description = defaultMeta.description,
    image = defaultMeta.image,
    url = defaultMeta.url,
    type = 'website',
    keywords = defaultMeta.keywords,
    noIndex = false,
}: SEOHeadProps) {
    const fullTitle = title
        ? `${title} | Publee`
        : defaultMeta.title;

    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            {noIndex && <meta name="robots" content="noindex, nofollow" />}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={url} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {/* Canonical */}
            <link rel="canonical" href={url} />
        </Helmet>
    );
}
